import { useEffect, useMemo, useState } from "react";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { COUNTRY_CODES, parsePhone } from "@/lib/constants";

export function PhoneInput({ value, onChange, testid }) {
  const parsed = useMemo(() => parsePhone(value), [value]);
  const [dial, setDial] = useState(parsed.dial);
  const [local, setLocal] = useState(parsed.local);
  const [ro, setRo] = useState(true);

  // Sync from an external value change (e.g. profile load) only when it differs
  // from what this component last produced — prevents a re-parse feedback loop.
  useEffect(() => {
    if (`${dial}${local}` !== (value || "")) {
      setDial(parsed.dial);
      setLocal(parsed.local);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const update = (d, l) => {
    const clean = (l || "").replace(/[^0-9]/g, "").slice(0, 10);
    setDial(d);
    setLocal(clean);
    onChange(clean ? `${d}${clean}` : "");
  };

  return (
    <div className="flex gap-2">
      <Select value={dial} onValueChange={(d) => update(d, local)}>
        <SelectTrigger data-testid={`${testid}-code`} className="w-[116px] shrink-0">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="max-h-64">
          {COUNTRY_CODES.map((c) => (
            <SelectItem key={c.code} value={c.code}>{c.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        data-testid={testid}
        inputMode="numeric"
        maxLength={10}
        name="rs-local-phone"
        autoComplete="off"
        autoCorrect="off"
        readOnly={ro}
        onFocus={() => setRo(false)}
        value={local}
        onChange={(e) => update(dial, e.target.value)}
        placeholder="10-digit number"
        className="flex-1"
      />
    </div>
  );
}
